// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const keldeo_resolute: PokeData = {
  "id": 10024,
  "name": "keldeo-resolute",
  "height": 14,
  "weight": 485,
  "base_experience": 290,
  "types": [
    PokeType.WATER,
    PokeType.FIGHTING
  ],
  "api_moves": [
    "swords-dance",
    "double-kick",
    "take-down",
    "leer",
    "hydro-pump",
    "bubble-beam",
    "helping-hand",
    "close-combat",
    "aqua-tail",
    "aqua-jet",
    "quick-guard",
    "retaliate",
    "work-up",
    "sacred-sword",
    "secret-sword"
  ],
  "moves": [
    "double-kick",
    "leer",
    "hydro-pump",
    "bubble-beam",
    "close-combat",
    "aqua-tail",
    "aqua-jet",
    "jump-kick",
    "brine",
    "liquidation",
    "vacuum-wave",
    "bulk-up",
    "meteor-assault"
  ],
  "evolution_chain": {
    "id": 334,
    "item": null,
    "species": [
      {
        "name": "keldeo",
        "order": 648,
        "types": [
          PokeType.WATER,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 111,
    "speed": 132,
    "ability_power": 158
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": false,
  "is_mythical": true,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
